import { render, staticRenderFns } from "./DeptList.vue?vue&type=template&id=7a39536c&scoped=true"
import script from "./DeptList.vue?vue&type=script&lang=js"
export * from "./DeptList.vue?vue&type=script&lang=js"
import style0 from "./DeptList.vue?vue&type=style&index=0&id=7a39536c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39536c",
  null
  
)

export default component.exports